import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";

import { useDispatch, useSelector } from "react-redux";
import { getAdaptiveFontSize } from "../../../../utils/styling.utils";
import { getBedSizeName } from "../../../../utils/bedBuilder.utils";
import {
  isSingleSleeperSelector,
  primarySleeperBmiSelector,
  secondarySleeperBmiSelector
} from "../../../../redux/slices/mattressConfiguration";
import {
  currentlyEditingSleeperSelector,
  setCurrentStack,
  setCurrentStepGeneral,
} from "../../../../redux/slices/customNavigation";
import GlobalEvrScore from "../../common/GlobalEvrScore";
import GlobalEvrScoreMobile from "../../common/GlobalEvrScoreMobile";
import Title from "../../BedSizeSelector/Title";
import singleIcon from "../../../../assets/images/mattresSizes/queen.svg";
import partnerIcon from "../../../../assets/images/mattresSizes/partner.svg";


import styled from "styled-components";

const StyledHeaderContainer = styled.div`
  z-index: 700;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  box-shadow: 0 1px 2px #000029;
  border-radius: 0 0 0 66px;
  height: 25%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background: transparent linear-gradient(160deg, #174d63 0%, #092c3b 100%) 0;
  overflow: auto;
`;
const StyledTitleContainer = styled.div`
  margin-top: 1rem;
  position: relative;
  left: -115px;
`;
const StyledImageContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
`;

const StyledTextContainer = styled.div`
  background: transparent linear-gradient(138deg, #ffffff 0%, #abe1fa 100%) 0 0
    no-repeat padding-box;
  border-radius: 15px 15px 15px 0;
  width: 145px;
  height: 90px;
  margin-left: -5%;
  margin-top: 1.5rem;
  padding-top: 10px;
`;

const MattressBuilderHeader = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSingleSleeper = useSelector(isSingleSleeperSelector);
  const bedSize = useSelector(state => {
    return state.mattressConfiguration.mattressConfiguration.bedSize;
  });
  //Media Queries
  const isSmartPhoneScreen = useMediaQuery("(min-width: 0px)");
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const screenWidthHooks = {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
  };

  return (
    <StyledHeaderContainer style={{ overflow: 'hidden' }}>
      <StyledTitleContainer>
        <Title
          styles={{
            fontSize: getAdaptiveFontSize({
              screenWidthHooks,
              fontSize: 2.6,
            }),
          }}
        >
          {t("evrbed")}
        </Title>
      </StyledTitleContainer>
      {!isMediumScreen && (
        <>
          <Button
            sx={{
              marginLeft: "-1rem",
              fontSize: "1rem",
              textDecoration: "underline",
              color: theme.COLORS.WHITE.backgroundWhite,
            }}
            onClick={() => {
              dispatch(setCurrentStepGeneral(0));
              dispatch(setCurrentStack("general"));
            }}
          >
            {t("Go Back")}
          </Button>
          <GlobalEvrScoreMobile></GlobalEvrScoreMobile>
        </>
      )}
      {isMediumScreen && (
        <div className="row" style={{ width: "100%" }}>
          <StyledImageContainer className="col-6">
            <img
              style={{
                backgroundColor: theme.COLORS.GREY.grey,
                height: "12vh",
                width: "6vw",
              }}
              src={isSingleSleeper ? singleIcon : partnerIcon}
            ></img>
          </StyledImageContainer>
          <StyledTextContainer
            className="col-6"
            style={{
              color: theme.COLORS.BLUE.darkBlueGreen2,
              fontSize: getAdaptiveFontSize({
                screenWidthHooks,
                fontSize: 0.7,
              }),
              marginLeft: '1rem',
            }}
          >
            {t(
              `You are personalizing a ${getBedSizeName(
                bedSize
              )} sized evrbed for ${
                isSingleSleeper ? "1 sleeper" : "2 sleepers"
              }`
            )}
            <br></br>
            <Button
              sx={{
                marginLeft: "-1rem",
                marginTop: "-0.7rem",
                textDecoration: "underline",
                color: theme.COLORS.BLUE.darkBlueGreen2,
              }}
              onClick={() => {
                dispatch(setCurrentStepGeneral(0));
                dispatch(setCurrentStack("general"));
              }}
            >
              {t("EDIT")}
            </Button>
          </StyledTextContainer>
        </div>
      )}
    </StyledHeaderContainer>
  );
};

export default MattressBuilderHeader;
